import { useCallback, useEffect } from 'react';

function useClickOutside(element, active, callback) {
    var handleClick = useCallback(function(e) {
        if (element.current != null && !element.current.contains(e.target)) {
            callback(e);
        }
    }, [
        callback,
        element
    ]);
    useEffect(function() {
        if (active) {
            document.addEventListener("mousedown", handleClick);
            document.addEventListener("touchstart", handleClick);
        } else {
            document.removeEventListener("mousedown", handleClick);
            document.removeEventListener("touchstart", handleClick);
        }
        return function() {
            document.removeEventListener("mousedown", handleClick);
            document.removeEventListener("touchstart", handleClick);
        };
    }, [
        active,
        handleClick
    ]);
}

export { useClickOutside };
